<template>
  <div>
    <!-- <vs-prompt
    @vs-close="close"
    @vs-cancel="close"
    @vs-accept="close"
    :vs-active.sync="show"
    vs-title="YEET">
    </vs-prompt> -->
    <vs-prompt
      @vs-cancel="close"
      @vs-accept="close"
      @vs-close="close"
      :vs-active.sync="show"
      :vs-buttons-hidden="true"
      vs-title="Scan Certificate QR Code"
      class="prompt">
      <div class="con-exemple-prompt">
        <div v-if="!scanned">
          <div v-if="!scanHide">
            <qrcode-stream @decode="onDecode"></qrcode-stream>
            <vs-button type="flat" @click="scanHide = true" style="color: #2f8ed2;">I would like to enter the code.</vs-button>
          </div>
          <div v-else>
            <div class="fill">
              <vs-input id="input" autofocus label="Enter your code:" class="inputx" placeholder="Code" v-model="input1" v-on:keydown.enter="send"/>
              <vs-button @click="send" class="btn">Send</vs-button>
            </div>
            <span v-show="warn">Missing Code</span>
            <vs-button style="margin-top: 10px;" type="flat" @click="scanHide = false">I would like to scan the QR code.</vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
    <vs-prompt
      @vs-cancel="close"
      @vs-accept="close"
      @vs-close="close"
      v-if="show2"
      :vs-active.sync="show2"
      :vs-buttons-hidden="true"
      vs-title="Verification"
      class="prompt2">
      <div v-if="loading">
        <h1>Loading...</h1>
      </div>
      <div v-if="success" class="con-exemple-prompt">
        <div class="header">
          <div v-if="equals" class="titleDiv">
            <h1 style="color: #00a1d7;">Blockchain Matched</h1>
            <img :src="matchedImg"/>
          </div>
          <div v-else class="titleDiv">
            <h1 style="">Blockchain Not Matched</h1>
            <img :src="notMatchedImg"/>
          </div>
        </div>
        <div class="body">
          <div class="keyDiv" v-for="(value, key) in parseJson(list[0].cap_payload)" :key="key">
            <span>{{key}}:</span>
            <span style="color: #8d8d8d;">{{value}}</span>
          </div>
          <div class="footer">
            <span>Issued by {{this.list[0].issuer_address}}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <h1>{{message}}</h1>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import Payload from '@/api/payload'
import User from '@/api/user'
import notMatchedImg from '@/assets/group-6029.png'
import matchedImg from '@/assets/group-6027.png'
import { setTimeout } from 'timers'
export default {
  name: 'Verifier',
  data () {
    return {
      show: false,
      show2: false,
      input1: '',
      warn: false,
      error: false,
      scanHide: false,
      scanned: false,
      success: false,
      message: '',
      loading: false,
      equals: false,
      list: [],
      matchedImg,
      notMatchedImg
    }
  },
  created () {
  },
  mounted () {
  },
  // beforeRouteEnter (to, from, next) {
  //   this.focusBoi()
  // },
  methods: {
    formatName (name, index) {
      return name || `Camera ${index}`
    },
    parseJson (value) {
      return JSON.parse(value)
    },
    close () {
      this.$parent.verify = false
      this.show = false
      this.show2 = false
      this.scanHide = false
      this.warn = false
      this.scanned = false
      this.success = false
      this.message = ''
      this.loading = false
      this.equals = false
      this.list = []
    },
    async fetchData (pbKey) {
      this.loading = true

      const userData = await User.login({
        token: process.env.VUE_APP_TOKEN
      })
      try {
        const response = await Payload.getAll(userData.jwt, pbKey)
        // console.log(response);
        if (response !== undefined) {
          if (response.data.length === 0) {
            this.success = false
            this.message = 'Certificate doesn\'t exist'
          } else {
            this.success = true
            if (response.data[0].verified) {
              this.equals = true
            } else {
              this.equals = false
            }
          }
        } else if (response === undefined) {
          this.message = 'Error'
        }
        this.list = response.data
      } catch (e) {
        this.success = false
        this.message = 'Certificate doesn\'t exist'
      }
      this.loading = false
      this.show = false
      this.show2 = true
    },
    async onDecode (decodedString) {
      console.log(decodedString)
      this.scanned = true
      this.fetchData(decodedString)
      // await this.close()
      // this.$router.push('/certificate/' + decodedString)
    },
    async send () {
      if (this.input1.trim() !== '') {
        this.warn = false
        this.scanned = true
        this.fetchData(this.input1)
        // await this.close()
        // this.$router.push('/certificate/' + this.input1)
      } else {
        this.warn = true
      }
    },
    focusBoi () {
      document.getElementById('input').focus()
    }
  },
  props: {
    open: Boolean
  },
  watch: {
    open: function (val) {
      this.scanHide = false
      this.show = val
      // this.fetchData('1B9A197C913E229DCC0323CCA42ADF96688B65C2CE34A62910D39308ECCF0D79')
      // const that = this
      // setTimeout(function () {
      //   that.focusBoi()
      // }, 10)
    },
    scanHide: function (val) {
      if (val === true) {
        const that = this
        setTimeout(function () {
          that.focusBoi()
        }, 10)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.prompt {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.prompt2 {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  .header {
    display: flex;
    align-self: flex-start;
    margin-left: 18px;
    @media screen and (max-width: 375px) {
      margin-left: 10px;
    }
    .titleDiv {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 20px;
        font-weight: 500;
        color: #e6242b;
        margin-right: 95px;
        text-align: left;
        width: 125px;
        @media screen and (max-width: 360px) {
          margin-right: 45px;
        }
      }
      img {
        width: 100px;
      }
    }
  }
  .body {
    height: 300px;
    margin-left: 10px;
    .keyDiv {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 60px;
      span {
        font-size: 16px;
        font-weight: bold;
        text-align: left;
      }
    }
    .footer {
      margin-top: 20px;
      margin-left: 20px;
      margin-right: 20px;
      padding-top: 10px;
      padding-bottom: 20px;
      font-size: 10px;
      border-top: rgba(112, 112, 112,0.7) 1px solid;
      height: 50px;
    }
  }
}
.con-exemple-prompt {
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: scroll;
  .fill {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    // h1 {
    //   font-size: 14px;
    // }
    .inputx {
      // .vs-con-input {
      //   .input-span-placeholder {
      //     color: #0f0;
      //   }
      // }
    }
    .btn {
      width: 60px;
      font-size: 12px;
      padding: 2px;
      margin-left: 5px;
      height: 30px;
    }
  }
}
span {
  word-wrap: break-word;
  word-break: break-all;
}
</style>
